// extracted by mini-css-extract-plugin
module.exports = {"container":"_2E9LSHSF6H2jTVigUKI5rf"};